module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-16.631b5e11.png";